module.exports = __webpack_public_path__ + "img/down-white-arrow.3d1e54f3.svg";